module.exports = __webpack_public_path__ + "fonts/acad0985/proximanova-regular-webfont.woff";